import { LynxTable } from "components/LynxTable/LynxTable";
import React from "react";
import { observer } from "mobx-react";
import { useStore } from "store/StoreConfigs";
import { LanesDetailsRequestModel } from "api/lokiRequestModels/lane/LanesDetailsRequestModel";
import { dateStartFormatting, dateEndFormatting } from "helpers/dateFormatting";
import { globalViewTableColumns } from "./TableColumns";
import ExpandableArea from "components/ExpandableArea/ExpandableArea";

export const GlobalViewTableWrapper = observer(function TableWrapper() {
    const { globalViewStore, filtersStore, identityStore } = useStore();

    const onSortChange = (id: string, sortDirection: "ASC" | "DESC") => {
        globalViewStore.setLaneSortProperty(id);
        globalViewStore.setLaneDirection(sortDirection);
    };

    const onPageChange = (direction: "back" | "forward") => {
        if (direction === "back") {
            globalViewStore.moveToPreviousLanePage();
        } else {
            const request: LanesDetailsRequestModel = {
                startTime: dateStartFormatting(filtersStore.startDate),
                endTime: dateEndFormatting(filtersStore.endDate),
                customerId: identityStore.currentCustomerId,
                lsp: filtersStore.selectedLogisticsServiceProviders.join(",") || undefined,
                productType: filtersStore.selectedProductTypes.join(",") || undefined,
                riskLevel: filtersStore.selectRiskLevels.join(",") || undefined,
                transportationModes: filtersStore.selectedModesOfTransportation.join(",") || undefined,
                packagingType: filtersStore.selectedPackagingTypes.join(",") || undefined,
                nextToken: globalViewStore.laneNextToken,
                sort: globalViewStore.laneSort,
                direction: globalViewStore.laneDirection,
            };

            globalViewStore.moveToNextLanePage(request);
        }
    };

    return (
        <LynxTable
            columns={globalViewTableColumns}
            rows={
                globalViewStore.lanePages.length === 0
                    ? []
                    : globalViewStore.lanePages[globalViewStore.currentLanesPage - 1]
            }
            rowKey="laneId"
            expandable
            expandableContent={(rowData) => <ExpandableArea laneId={rowData.laneId} />}
            page={globalViewStore.currentLanesPage}
            isLastPage={globalViewStore.isLastLanePage}
            onPageChange={onPageChange}
            sortedBy={globalViewStore.laneSort}
            sortDirection={globalViewStore.laneDirection}
            onSortChange={onSortChange}
            isLoading={globalViewStore.loadingLanes}
        />
    );
});
